import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 
import {thunk} from 'redux-thunk'; 
import rootReducer from './Reducers'; 

// Configuration pour redux-persist
// 🐛 [TEMP] whitelist vide → rien n'est persisté → tout repart à zéro à chaque reload.
// Permet de tester l'UX sans rehydration. À ENLEVER après le test.
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [],
};

// Création du reducer persistant
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configuration du store avec redux-thunk
const store = createStore(
  persistedReducer,
  applyMiddleware(thunk) // Ajout de thunk comme middleware
);

// Configuration de redux-persist pour persister les données
const persistor = persistStore(store);

export { store, persistor };
